import { Component, OnInit, OnDestroy, Directive, Input, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatSnackBar, MatTableDataSource, MatPaginator } from '@angular/material';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { CaseService } from '../../../shared/services/case.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { environment } from '../../../../../environments/environment';
import { OrganizationServices } from '../../../shared/services/organization.services';

@Component({
  selector: 'recentActivity',
  templateUrl: './recentActivity.component.html',
  styleUrls: ['./recentActivity.component.scss'],
  providers: [

  ]
})
export class EguardRecentActivityComponent implements OnInit {
  displayedColumns: string[] = ['case_id', 'time', 'message'];
  recentActivities = new MatTableDataSource();
  org: string;
  id: string;
  token: string;
  role: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // recentActivities: any = [];
  loading = true;

  error = '';

  dialogRef: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private caseService: CaseService,
    public dialog: MatDialog,
    private cognito: CognitoUtil,
    public snackBar: MatSnackBar,
    private organizationService: OrganizationServices,
    private localUser: LocalUserService
  ) {

  }

  ngOnInit() {
    this.role = this.localUser.getRole();
    this.id = this.localUser.getUserId();
    this.org = this.localUser.getOrganizationId();
    this.getRecentActivity();
  }

    ngAfterViewInit() {
    this.recentActivities.paginator = this.paginator;
  }

  openCase(caseData) {
    {
      this.router.navigate(['case', this.org, this.getParentCaseOtherwiseReturnId(caseData)]);
    }
  }

  getParentCaseOtherwiseReturnId(data) {
    if (data.parentCase !== undefined && data.parentCase !== null) {
      return data.parentCase;
    }
    return data.case_id;
  }

  getRecentActivity() {

    this.recentActivities.data = [];
    this.loading = true;

    this.organizationService.getRecentActivity(this.org)
      .subscribe(
        result => {
          // this will sorta array for descending order
          result.sort(function (x, y) {
            return y.time - x.time;
          });

          this.recentActivities.data = result;
          this.loading = false;
        },
        error => {
          this.error = 'This page had an error please refresh if this continues contact support';
          this.snackBar.open(this.error, '', {
            duration: environment.snackBarErrorLength,
          });
        });
  }

  cleanDate(date) {
    let temp = new Date(date);
    return (temp.getMonth() + 1) + '/' + temp.getDate() + '/' + temp.getFullYear();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/recentActivity/recentActivity.component.ts